const PRICING = '/pricing';
const ISSUERS_LIST = '/list-of-global-fixed-income-issuers';
const SPONSORS_LIST = '/list-of-global-fixed-income-corporate-sponsors';
const LEAGUE_TABLE = '/fixed-income-underwriter-rating-agency-league-table';
const SUBSCRIPTIONS = '/subscriptions';
const SETTINGS = '/settings';
const OPEN_MARKET = '/openmarket';
const EXCEL_ADD_IN_GUIDE_POLICY = '/excel-add-in/privacy-policy';
const EXTERNAL_API = '/external-api';
// TODO: Replace with internal route when API docs page is ready
const EXTERNAL_API_DOCS = 'https://api.finsight.com/external/docs/creditflow-api/v1';

export default {
  BASE: '/',
  DEAL: '/deal',
  ISSUER: '/issuer',
  SPONSOR: '/sponsor',
  POLICIES: '/policies',
  CORPORATE_BONDSCREENER: '/bond-screener/corporate-bonds',
  CORPORATE_BONDSCREENER_DEAL: '/bond-screener/corporate-bonds/deal',
  EXTERNAL_LINK: '/external-link',
  BONDS: '/bonds',
  NOTIFICATION_UNSUBSCRIBE: '/notification/unsubscribe',
  NOT_FOUND: '/404',
  UNDERWRITER_RATING_AGENCY_LEAGUE_TABLE: '/:leagueType(underwriter|rating-agency)-:viewId-:companyName?',
  LEAGUE_TABLE,
  LEAGUE_TABLE_ALL_COMPANIES: '/fixed-income-underwriter-rating-agency-league-table/all',
  LEAGUE_TABLE_UNDERWRITERS: '/fixed-income-underwriter-rating-agency-league-table/underwriters',
  LEAGUE_TABLE_RATING_AGENCIES: '/fixed-income-underwriter-rating-agency-league-table/rating-agencies',
  OPEN_MARKET,

  // new routes from seo epic
  PRICING,
  EXCEL_ADD_IN_GUIDE_POLICY,
  EXTERNAL_API,
  EXTERNAL_API_DOCS,
  BONDS_BWICS: '/bwics',
  BONDS_INVENTORIES: '/inventories',
  BONDS_INVENTORIES_ABS: '/inventories-abs', // abs = asset class selected by default on bwics/inventories page
  TRACE: '/trace',
  OM_LIBRARY: '/om-library',
  BONDS_SUMMARY_BASE: '/dealer-summary',
  BONDS_BWICS_SUMMARY: '/dealer-summary-bwics',
  BONDS_INVENTORIES_SUMMARY: '/dealer-summary-inventories',
  PRODUCT_US_ABS_EE: '/us-abs-loan-level-data-on-edgar',
  PRODUCT_US_ABS_PIPELINE: '/us-abs-new-issue-pipeline',
  MARKET_OVERVIEW_ALL: '/all-abs-market-bond-issuance-overview',
  MARKET_OVERVIEW_HYC: '/high-yield-corporate-bond-issuance-overview',
  MARKET_OVERVIEW_IGC: '/investment-grade-corporate-bond-issuance-overview',
  MARKET_OVERVIEW_CONSUMER: '/abs-exclos-cmbs-rmbs-market-bond-issuance-overview',
  MARKET_OVERVIEW_EM: '/em-market-overview',
  ABS_BONDSCREENER: '/bond-screener/asset-backed-securities',
  STRATS: '/us-abs-loan-level-data-on-edgar/stratmaker',
  NRSRO_RESEARCH: '/fixed-income-research',
  NRSRO_RESEARCH_REPORTS: '/fixed-income-research/reports',
  ISSUERS_LIST,
  SPONSORS_LIST,
  SUBSCRIPTIONS,
  SETTINGS,
  PORTFOLIO_MONITOR: '/portfolio-monitor',
  CREDIT_FLOW_ARTICLE: '/post',
  CREDIT_FLOW_ARTICLE_LIST_ALL: '/commentary-deal-flow-all',
  CREDIT_FLOW_STATS_LIST_BASE: '/new-issue-stats',
  CREDIT_FLOW_STATS_LIST_ALL: '/new-issue-stats-all',
  CREDIT_FLOW_STAT: '/stat',
  ABS_ACTIVE_CALENDAR: '/active-calendar/abs',
  CORPORATE_ACTIVE_CALENDAR: '/active-calendar/corporate',
  EUROPE_ACTIVE_CALENDAR: '/active-calendar/europe',
  ABS_CFX_INDICES: '/cfrx-indices/abs',
  CORPORATE_CFX_INDICES: '/cfrx-indices/corporate',
  CFX_INDEX_RULES_METHODOLOGY: '/cfrx-indices/index-rules-methodology',
  ASK_AI: '/ask-ai',

  // suffixes to create url for profile pages
  INDUSTRY_SUFFIX: 'bond-issuance-overview',
  SECTOR_SUFFIX: 'abs-bond-issuance-overview',
  // end suffixes to create url for profile pages

  STATIC_PAGES_LIST: [
    ISSUERS_LIST,
    SPONSORS_LIST,
    SUBSCRIPTIONS,
    SETTINGS,
    PRICING,
    EXCEL_ADD_IN_GUIDE_POLICY,
    EXTERNAL_API,
    EXTERNAL_API_DOCS,
  ],
};
